import React, { useEffect } from "react";
import { Route, Routes, Outlet, useParams } from "react-router-dom";
import { HomeDashboardLayout } from "../../Layout";
import sidebarMenus from "../../constants/sidebarMenus";
import { getStorage } from "../../utils/storage";
import AggregatorCollectionsScreenScreen from "./AggregatorCollectionsScreenScreen";
import CollectionAccountsScreen from "./CollectionAccountsScreen";
import { connect } from "react-redux";
import ChargesScreen from "./ChargesScreen";
import InvoicePreviewScreen from "./InvoicePreviewScreen";
import ShiftsTransactionDetail from "./reports/shifts/ShiftsTransactionDetail";

const HomeDashboardScreen = (props) => {
  const routes = [...(sidebarMenus(props.defaultLanguage) || [])];

  useEffect(() => {
    async function userInfo() {
      const user = await getStorage();

      if (!user.accessToken) return (window.location.href = "/");
    }

    userInfo();
  });

  return (
    <HomeDashboardLayout {...useParams()}>
      <Routes>
        {routes.map((route, index) => {
          return (
            <>
              <Route key={index} path={route.path} element={route.component} />

              {route.menus && (
                <Route
                  key={index}
                  path={route.path + "/*"}
                  element={subMenusRoutes(route)}
                />
              )}
            </>
          );
        })}
        <Route
          path="/aggregator/collections"
          element={<AggregatorCollectionsScreenScreen />}
        />
         <Route
          path="/shift-report/shifts/transactions"
          element={<ShiftsTransactionDetail />}
        />
        <Route
          path="/collection/accounts"
          element={<CollectionAccountsScreen />}
        />
        <Route path="/account/charges" element={<ChargesScreen />} />
        <Route
          path="/invoice/:invoiceNumber"
          element={<InvoicePreviewScreen />}
        />
      </Routes>
      <Outlet />
    </HomeDashboardLayout>
  );
};

const subMenusRoutes = (route) => {
  return (
    <Routes>
      <Route path="/" element={route.component} />
      {route.menus.map((el, index) => {
        return (
          <>
            <Route key={index} path={el.path} element={el.component} />
          </>
        );
      })}
    </Routes>
  );
};
const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};
export default connect(mapStateToProps)(HomeDashboardScreen);
